export type AccordionItem = {
  title: string;
  description: string;
};

type AccordionProps = {
  items: AccordionItem[];
  defaultOpenIndex?: number;
};

const ChevronIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className="shrink-0 transition-transform duration-200 group-open:rotate-180"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const Accordion = ({ items, defaultOpenIndex = 0 }: AccordionProps) => (
  <div className="divide-y divide-[#EBEBEB] border-b border-[#EBEBEB]">
    {items.map((item, index) => (
      <details
        key={item.title}
        open={index === defaultOpenIndex}
        className="group"
      >
        <summary className="flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-[16px] font-semibold [&::-webkit-details-marker]:hidden">
          {item.title}
          <ChevronIcon />
        </summary>
        <p className="max-w-[520px] pb-5 text-sm leading-relaxed text-[#3D3C56]">
          {item.description}
        </p>
      </details>
    ))}
  </div>
);
